import { createApp } from "vue"
import PrimeVue from "primevue/config"
import App from "./App.vue"
import router from "./router"
// @ts-ignore
import Preset from "./preset"
import "./style.css"

const app = createApp(App)

app.use(router)

app.use(PrimeVue, {
	unstyled: true,
	pt: Preset,
	locale: {
		firstDayOfWeek: 1,
		dayNames: [
			"Sonntag",
			"Montag",
			"Dienstag",
			"Mittwoch",
			"Donnerstag",
			"Freitag",
			"Samstag",
		],
		dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
		dayNamesMin: ["S", "M", "D", "M", "D", "F", "S"],
		monthNames: [
			"Januar",
			"Februar",
			"März",
			"April",
			"Mai",
			"Juni",
			"Juli",
			"August",
			"September",
			"Oktober",
			"November",
			"Dezember",
		],
		monthNamesShort: [
			"Jan",
			"Feb",
			"Mär",
			"Apr",
			"Mai",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Okt",
			"Nov",
			"Dez",
		],
	},
})

app.mount("#app")
